import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetRecomendationsByResultId = (resultId, options = {}) => {
  const query = useApiQuery(
    ['recommendationsByResultId', resultId],
    'schools',
    `current-organization/results/${resultId}/recommendation`,
    {
      enabled: Boolean(resultId),
      ...options
    },
    {
      version: 4,
      authenticated: true
    }
  )

  return {
    ...query,
    loading: query.isLoading
  }
}
